
import { defineComponent } from 'vue'

import PageContent from '@/components/page-content'
export default defineComponent({
  name: 'overive',
  components: {
    PageContent
  },
  setup() {
    return {
    }
  }
})
